const map = {
	"./course-01.jpg": 1951,
	"./course-02.jpg": 87600,
	"./course-03.jpg": 39821,
	"./course-04.jpg": 20742,
	"./course-05.jpg": 80227,
	"./course-06.jpg": 34164,
	"./course-07.jpg": 48497,
	"./course-08.jpg": 77386,
	"./course-09.jpg": 33223,
	"./course-10.jpg": 68825,
	"./course-11.jpg": 24476,
	"./course-12.jpg": 49643,
	"./course-13.jpg": 70158,
	"./course-14.jpg": 7221,
	"./course-15.jpg": 23659,
	"./course-16.jpg": 78887,
	"./course-17.jpg": 83082
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9343;